import { Box } from '@chakra-ui/layout';
import { FormattedMessage } from 'react-intl';

import { H3 } from '@/components/Heading';

type NotFoundProps = {
    message: string;
};

function NotFound(props: NotFoundProps) {
    const { message } = props;

    return (
        <Box textAlign="center">
            <H3>
                <FormattedMessage id={message || 'not-found'} />
            </H3>
        </Box>
    );
}

export default NotFound;
